/**
 * @format
 * @description No ads (except for the hidden "html" slot). Used for `noAds` category.
 */
export default {
  // available-slots-for-tier: {
  //   html: [],
  // },
  mobile: {
    html: [[1, 1]]
  },
  portrait: {
    html: [[1, 1]]
  },
  landscape: {
    html: [[1, 1]]
  },
  desktop: {
    html: [[1, 1]]
  }
};
